var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashBin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "-3 -3 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3779 1.64995L6.55358 1.64803L6.68946 1.53663L7.78981 0.634442L12.4269 0.583708L13.5466 1.4616L13.6849 1.57L13.8606 1.56808L19.5962 1.50533L19.6071 2.50527L18.86 2.51344L18.36 2.51891L18.3654 3.01888L18.5288 18.018C18.5328 18.387 18.3685 18.7783 18.0185 19.0652C17.6596 19.3595 17.1161 19.5335 16.5509 19.5397L4.0797 19.6762C3.51449 19.6823 2.96728 19.5202 2.60205 19.2339C2.24595 18.9547 2.07312 18.5671 2.0691 18.1981L1.90574 3.19897L1.90029 2.699L1.40032 2.70447L0.653175 2.71264L0.642283 1.7127L6.3779 1.64995ZM3.89455 2.67718L3.39458 2.68265L3.40003 3.18262L3.5634 18.1817L3.56884 18.6817L4.06881 18.6762L16.54 18.5398L17.0399 18.5343L17.0345 18.0343L16.8711 3.03523L16.8657 2.53526L16.3657 2.54073L3.89455 2.67718ZM8.52463 15.6273L7.03034 15.6436L6.92143 5.64424L8.41572 5.62789L8.52463 15.6273ZM13.5131 15.5727L12.0188 15.5891L11.9099 5.58966L13.4042 5.57331L13.5131 15.5727Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashBin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/trash_bin.d7a502111c60c1084071932e2e5b283e.svg";